<template>
  <v-bottom-sheet
    :value="value"
    rounded="xl b-0"
    inset
    :max-width="maxAppWidth"
    @input="$emit('input', $event)"
  >
    <v-sheet class="px-4 py-6" rounded="xl b-0">
      <div class="d-flex flex-row align-center justify-space-between pb-4">
        <span class="tp-text-subtitle-semibold">
          {{ $t('screens.order.severalOrdersTitle') }}
        </span>
        <img
          :src="require(`@/assets/images/icons/chevron-down-white-icon.svg`)"
          @click="$emit('input', false)"
        />
      </div>
      <div class="tp-text-body-gray">
        {{ $t('screens.order.severalOrdersSubtitle') }}
      </div>
      <v-list flat class="pt-4">
        <v-list-item
          v-for="(order, index) in orders"
          :key="order.unique_order_number"
          class="pa-0"
          :ripple="false"
          data-cy="pay-go-table-order"
          @click="select(order)"
        >
          <v-list-item-content>
            <v-list-item-title class="tp-text-body-2">
              {{ $t('screens.order.severalOrdersOption', { number: index + 1 }) }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="mr-0 flex-row align-center">
            <v-icon v-if="isPaid(order)" small color="#489F31" class="mr-1">
              mdi-check-circle
            </v-icon>
            <span class="tp-text-body-2 mr-2">
              {{ $store.getters.getFormattedPrice(order.total) }}
            </span>
            <v-checkbox
              color="black"
              class="mr-0"
              :ripple="false"
              :input-value="order.unique_order_number === selected"
              @change="select(order)"
            />
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    orders: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      default: null,
    },
  },
  methods: {
    isPaid(order) {
      return order.status === 'closed' || order.is_paid;
    },
    select(order) {
      this.$emit('select', order.unique_order_number);
      this.$emit('input', false);
    },
  },
};
</script>
